import React, { useEffect } from 'react';
import { Button, Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useLazyGetEmployeeDetailsQuery } from "../../../features/admin/employee/employeeSlice";
import { useCreateTripMutation, useEditTripMutation, useGetAllPortEntriesQuery, 
  useLazyGetActiveTripsListQuery, useUpdateTripStatusMutation, useGetAllTrailersQuery,
  useAssignLineHaulerToTripMutation } from "../../../features/Dispatch/TripDispatchSlice";
import TextField from '../../designSystem/TextField';
import { format, parseISO } from 'date-fns';
import CloseButton from 'react-bootstrap/CloseButton';
import PrintIcon from '@mui/icons-material/Print';
import errorHandler from '../../hooks/ErrorHanlder';


const LoadingPage = (props) => {
  const tripData = props?.selectedTripDetails?.data?.data;
  const currentDate = format(new Date(), 'yyyy-MM-dd')
  const { register, handleSubmit, watch, formState: { errors }, setValue, getValues, reset } = useForm({
    defaultValues: props?.selectedTripDetails && props.isEditActiveTrip ? {
      ...tripData,
      startDate: format(parseISO(tripData?.startDate), "yyyy-MM-dd"),
      departureTime: tripData?.departureTime === "" ? currentDate : tripData?.departureTime,
      estimatedBorderCrossDate: tripData?.estimatedBorderCrossDate === "" ? currentDate : tripData?.estimatedBorderCrossDate,
    } : {
      tripStatusID: 2,
      startDate: "",
      destination: "",
      unit: "",
      vehicle: "",
      plate: "",
      state: "",
      portNo: "",
      skids: "",
      weight: "",
      feet: "",
      stops: "",
      needs: "",
      lineHauler: "",
      lineHaulerName: "",
      phoneNumber: "",
      secondaryDriver: "",
      departureTime: currentDate,
      estimatedBorderCrossDate: currentDate,
      estimatedBorderCrossTime: "",
      trailerNo: "",
      trailerPlate: "",
      sealNo: "",
      switchTrailerNo: "",
      switchTrailerPlate: "",
      divisionID: 0
    }
  });

  const [getEmployeeDetails, employeeResults] = useLazyGetEmployeeDetailsQuery()
  const [getActiveTripsList] = useLazyGetActiveTripsListQuery();
  const [updateTripStatus] = useUpdateTripStatusMutation()
  const [assignLineHaulerToTrip] = useAssignLineHaulerToTripMutation()
  const { data: trailers } = useGetAllTrailersQuery();
  const [createTrip] = useCreateTripMutation()
  const [editTrip] = useEditTripMutation()
  const { data: portEntries } = useGetAllPortEntriesQuery();
  const selectedState = watch("state");
  const currentDriver = props.driverList?.data?.data?.find((driver) => driver?.driverNumber == props?.selectedDriver?.driverNumber);
  const isEmployee = currentDriver?.driverType == "Employee";
  const trailersList = trailers?.data?.filter((trailer) => trailer.trailerNo != getValues("switchTrailerNo")) || [];
  const switchTrailersList = trailers?.data?.filter((trailer) => trailer.trailerNo != getValues("trailerNo")) || [];

  useEffect(() => {
    if (watch('trailerNo')) {
      setValue('trailerPlate', trailers?.data?.find((trailer) => trailer.trailerNo == getValues("trailerNo"))?.licensePlateNo)
    }
    else {
      setValue('trailerPlate', "")
    }
  }, [getValues("trailerNo")])

  useEffect(() => {
    if (watch('switchTrailerNo')) {
      setValue('switchTrailerPlate', trailers?.data?.find((trailer) => trailer.trailerNo == getValues("switchTrailerNo"))?.licensePlateNo)
    }
    else {
      setValue('switchTrailerPlate', "")
    }
  }, [getValues("switchTrailerNo")])

  const handleLineHaulerClear = () => {
    setValue("lineHauler", "");
    setValue("unit", "");
    setValue("vehicle", "");
    setValue("plate", "");
    setValue("phoneNumber", "");
  };
  function resetStates() {
    props.setShowNewTrip(false);
    props.setIsEditActiveTrip(false);
    props.setSelectedTrip(null);
  }


  useEffect(() => {
    if (props.isEditActiveTrip && tripData && tripData?.startDate) {
      reset({
        ...tripData,
        startDate: format(parseISO(tripData?.startDate), "yyyy-MM-dd"),
        departureTime: tripData?.departureTime === "" ? currentDate : tripData?.departureTime,
        estimatedBorderCrossDate: tripData?.estimatedBorderCrossDate === "" ? currentDate : tripData?.estimatedBorderCrossDate,
      });
    }
  }, [tripData, reset, props.isEditActiveTrip]);

  const handleCreateTrip = handleSubmit(async (values) => {
    const result = await createTrip({ ...values, divisionID: props.divisionId, tripStatusID: 2, startDate: new Date(values?.startDate).toISOString() })
    if (result.data?.statusCode === 200) {
      toast.success('Trip created successfully', {
        position: "top-center"
      });
      props.setShowNewTrip(false)
      getActiveTripsList(props.divisionId)
    }
    else {
      toast.error(result.error.data.message, {
        position: "top-center"
      });
    }
  })
  const handleEditTrip = handleSubmit(async (values) => {
    const result = await editTrip({ ...values, divisionID: props.divisionId, tripStatusID: 2, startDate: new Date(values?.startDate).toISOString() })
    if (result.data.statusCode === 200) {
      toast.success('Trip Updated successfully', {
        position: "top-center"
      });
      const lineHaulAssign = await assignLineHaulerToTrip({ tripID: values.tripID, tripNumber: values.tripNo,
      lineHaulerDriverNumber: values.lineHauler, divisionID: props.divisionId })
      if (lineHaulAssign.data.statusCode === 200) {
        await getActiveTripsList(props.divisionId)
        resetStates()
      }
      else {
        errorHandler(lineHaulAssign);
      }
    }
    else {
      toast.error('Failed to Update trip', {
        position: "top-center"
      });
    }
  })

  const handleLineHaulerClick = () => {
    if (props.selectedDriver && props.selectedDriver.driverNumber === getValues("secondaryDriver")) {
      toast.error('Driver has already been selected for Secondary Driver', { position: 'top-center' });
      return;
    }
    if (!watch("lineHauler") && props.selectedDriver) {
      setValue("lineHauler", props.selectedDriver.driverNumber);
      setValue("unit", props.selectedDriver.assignedUnit || "None");
      setValue("phoneNumber", currentDriver?.driverPhoneNumber);
      setValue("plate", props.selectedDriver.plateNumber)
      setValue("vehicle", props.selectedDriver.vehicleType)
    } else {
      setValue("unit", "")
      setValue("vehicle", "")
      setValue("plate", "")
      console.error("No driver selected or already set");
    }
  };

  const handleSecondaryDriverClick = () => {
    if (!watch("secondaryDriver") && props.selectedDriver && props.selectedDriver.driverNumber !== getValues("lineHauler")) {
      setValue("secondaryDriver", props.selectedDriver.driverNumber);
    } else {
      if (props.selectedDriver) {
        toast.error('Driver has already been selected for Line-Hauler', { position: 'top-center' });
      }
      console.error("No driver selected or already set");
    }
  };

  const tripMovement = async (event, code) => {
    if (!props.selectedTripDetails.data) {
      toast.error('No trip selected', {
        position: "top-center"
      });
      return;
    }
    const result = await updateTripStatus({ tripID: props.selectedTripDetails?.data?.data?.tripID, newStatusCode: code, divisionID: props.divisionId })
    if (result.data?.statusCode === 200) {
      toast.success('Trip status updated successfully', {
        position: "top-center"
      });
      props.setSelectedTrip(null)
      await getActiveTripsList(props.divisionId)
      await props.getSelectedTripDetails({ tripId: props.selectedTripDetails?.data?.data?.tripID, divisionId: props.divisionId })
    }
    else if (result.error?.status === 400) {
      toast.error(result.error.data?.message, {
        position: "top-center"
      });
      event.target.checked = false;
    }
  }

  return (
    <Col sm={12}>
        <fieldset style={{borderRadius:"5px 5px 0px 0px"}} className='createNewTrip mt-2 d-flex justify-content-between'>
          <h6>{props.isEditActiveTrip ? "Edit Trip" : "Create New Trip"}</h6>
        </fieldset>
        <fieldset style={{borderRadius:"0px 0px 5px 5px", borderTop:"none"}}>
          <div className="create-form-container">
            {props.isEditActiveTrip ? <TextField label="tripNo"  {...register("tripNo", { required: "Field is required" })} disabled /> : null}
            <FloatingLabel controlId="startDate" label="Start Date" >
              <Form.Control type="date"{...register("startDate", { required: "Field is required" })} />
              {errors?.startDate?.message && <p className="text-danger m-0">{errors?.startDate?.message}</p>}
            </FloatingLabel>
            <TextField label="Destination"  {...register("destination", { required: "Field is required" })} error={errors?.destination?.message} />
            <div style={{ position: "relative", display: "inline-block" }}>
              <TextField label="Line-Hauler" onClick={handleLineHaulerClick} disabled={watch("lineHauler")} {...register("lineHauler")} />
              {getValues('lineHauler') && (
                <button
                  onClick={handleLineHaulerClear}
                  style={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                >
                  <CloseButton />
                </button>
              )}
            </div>
            <div style={{ position: "relative", display: "inline-block" }}>
              <TextField label="Secondary Driver" onClick={handleSecondaryDriverClick} disabled={watch("secondaryDriver")} {...register("secondaryDriver")} />
              {getValues('secondaryDriver') && (
                <button
                  onClick={() => setValue('secondaryDriver', '')}
                  style={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                >
                  <CloseButton />
                </button>
              )}
            </div>
            <TextField label="Unit#"  {...register("unit")} disabled />
            <TextField label="Vehicle"  {...register("vehicle")} disabled={props.selectedDriver && props.selectedDriver.vehicleType && getValues("vehicle") !== ""} />
            <TextField label="Plate"  {...register("plate")} disabled={props.selectedDriver && props.selectedDriver.name && getValues("plate") !== ""} />
            <FloatingLabel controlId="floatingSelectGrid" label="State">
              <Form.Select aria-label="State" {...register("state")}>
                <option value="">Select</option>
                {portEntries?.data?.reduce((agg, val) => {
                  if (!agg.includes(val.stateCode)) { agg.push(val.stateCode) }
                  return agg;
                }, []).map((state) => (
                  <option key={state} value={state}>{state} </option>
                ))}
              </Form.Select>
            </FloatingLabel>
            <FloatingLabel controlId="floatingSelectGrid" label="Port">
              <Form.Select aria-label="Port" {...register("portNo")}>
                <option value="">Select</option>
                {portEntries?.data?.filter(
                  (port) => port.stateCode === selectedState
                ).map((port) => (
                  <option key={port.portCode} value={port.portCode}>{port.portCode} ({port.portName})</option>
                ))}
              </Form.Select>
            </FloatingLabel>
            <TextField label="Phone Number" {...register("phoneNumber")} />
            <TextField label="Skids"  {...register("skids")} />
            <TextField label="Wgt"  {...register("weight")} />
            <TextField label="Feet"  {...register("feet")} />
            <TextField label="Stops" {...register("stops")} />
            <TextField label="Needs" {...register("needs")} />
          </div>
          <fieldset className='mt-4'>
            <label htmlFor="" className='label-heading '>Trailer Info</label>
            <div className="create-form-container">
              <FloatingLabel controlId="floatingSelectGrid" label="Trailer No">
              <Form.Select aria-label="Trailer No" {...register("trailerNo")}>
                <option value="">Select</option>
                {trailersList?.map((trailer) => (
                  <option key={trailer.trailerNo} value={trailer.trailerNo}>{trailer.trailerNo} </option>
                ))}
              </Form.Select>
            </FloatingLabel>
              <TextField label="Trailer Plate" disabled value={getValues('trailerPlate')} {...register("trailerPlate")} />
              <TextField label="Seal No"  {...register("sealNo")} />
              <FloatingLabel controlId="floatingSelectGrid" label="Switch Trailer No">
               <Form.Select aria-label="Switch Trailer No" {...register("switchTrailerNo")}>
                 <option value="">Select</option>
                 {switchTrailersList?.map((trailer) => (
                   <option key={trailer.trailerNo} value={trailer.trailerNo}>{trailer.trailerNo} </option>
                 ))}
               </Form.Select>
             </FloatingLabel>
               <TextField label="Switch Trailer Plate" disabled value={getValues('switchTrailerPlate')} {...register("switchTrailerPlate")} />
            </div>
          </fieldset>
          <Row className='mt-4'>
            <Col sm={4}>
              <fieldset>
                <label htmlFor="" className='label-heading'>Departure time</label>
                <Col>
                  <FloatingLabel controlId="departureTime" label="Departure Time" >
                    <Form.Control
                      type="date"
                      {...register("departureTime")}
                    />
                  </FloatingLabel>
                </Col>
              </fieldset>
            </Col>
            <Col sm={8}>
              <fieldset>
                <label htmlFor="" className='label-heading'>Estimated X border time</label>
                <Row>
                  <Col>
                    <FloatingLabel controlId="estimatedBorderCrossDate" label="Estimated Border Cross Date" >
                      <Form.Control
                        type="date"
                        {...register("estimatedBorderCrossDate")}
                      />
                    </FloatingLabel>
                  </Col>
                  <Col>
                    <FloatingLabel controlId="estimatedBorderCrossTime" label="Estimated Border Cross Time" >
                      <Form.Control
                        type="time"
                        {...register("estimatedBorderCrossTime")}
                      />
                    </FloatingLabel>
                  </Col>
                </Row>
              </fieldset>
            </Col>
          </Row>
          {(props.selectedTab === 2) && (
            <fieldset className='mt-4'>
              <label htmlFor="" className='label-heading'>Status</label>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Ready"
                  {...register("ready")}
                  inline
                  checked={props.selectedTripDetails?.data?.data?.isReady}
                  onClick={(e) => tripMovement(e, "READY")}
                />
                <Form.Check
                  type="checkbox"
                  label="CBP"
                  {...register("cbp")}
                  inline
                />
                <Form.Check
                  type="checkbox"
                  label="Outbound"
                  {...register("outbound")}
                  inline
                  onClick={(e) => tripMovement(e, "OUT")}
                />
              </Form.Group>
            </fieldset>)}
          {(props.selectedTab === 3) && (
            <fieldset className='mt-4'>
              <label htmlFor="" className='label-heading'>Status</label>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="CBP"
                  {...register("cbp")}
                  inline
                />
                <Form.Check
                  type="checkbox"
                  label="Inbound"
                  {...register("inbound")}
                  inline
                  onClick={(e) => tripMovement(e, "IN")}
                />
              </Form.Group>
            </fieldset>)}
          {props.selectedTab === 4 && (
            <fieldset className='mt-4'>
              <label htmlFor="" className='label-heading'>Status</label>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="CBP"
                  {...register("cbp")}
                  inline
                />
                <Form.Check
                  type="checkbox"
                  label="Close Trip"
                  {...register("closeTrip")}
                  inline
                  onClick={(e) => tripMovement(e, "C")}
                />
              </Form.Group>
            </fieldset>)}
          <Row className="mt-4 mb-3">
            <Col className="d-flex align-items-center justify-content-center">
              <Form.Check
                type="radio"
                label="Outbound Orders"
                checked={props.classificationRadio === 1}
                onClick={() => props.setClassificationRadio(1)}
              />
            </Col>
            <Col className="d-flex align-items-center justify-content-center">
              <Form.Check
                type="radio"
                label="Inbound Orders"
                checked={props.classificationRadio === 2}
                onClick={() => props.setClassificationRadio(2)}
              />
            </Col>
            <Col className="d-flex align-items-center justify-content-center">
              <Form.Check
                type="radio"
                label="Trip & return orders"
                checked={props.classificationRadio === 3}
                onClick={() => props.setClassificationRadio(3)}
              />
            </Col>
            <Col className="d-flex align-items-center justify-content-center">
              <Form.Check
                type="radio"
                label="Driver routing"
                checked={props.classificationRadio === 4}
                onClick={() => props.setClassificationRadio(4)}
              />
            </Col>
            <Col xs="auto">
              <Button>
                <PrintIcon /> Print Manifest
              </Button>
            </Col>
          </Row>
          <div className='px-3'>
            <Row className="my-4 d-flex justify-content-lg-between gap-2" >
              <Col xs={12} lg="auto" className='p-0'>
                <Button variant="outline-primary" >Driver Routing</Button>
              </Col>
              <Col xs={12} lg="auto" className='p-0'>
                <Button variant="outline-primary" >US Manifest</Button>
              </Col>
              <Col xs={12} lg="auto" className='p-0'>
                <Button variant="outline-primary" >Fax Covers</Button>
              </Col>
              <Col xs={12} lg="auto" className='p-0'>
                <Button variant="outline-primary" >B.O.L.</Button>
              </Col>
              <Col xs={12} lg="auto" className='p-0'>
                <Button variant="outline-primary" >Transmit</Button>
              </Col>
            </Row>
          </div>
              <div className='d-flex justify-content-end'>
                <div className='d-flex gap-2'>
                  <Button variant="secondary" style={{ width:"100px"}} onClick={(e) => props.isEditActiveTrip ? handleEditTrip(e) : handleCreateTrip(e)}>Save</Button>
                  <Button size='lg' style={{ height: "100%",width:"100px" }} variant="outline-primary" onClick={resetStates}>Exit</Button>
                </div>
              </div>
        </fieldset>
    </Col>
  )
}

export default LoadingPage